import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Archivo } from '@models/archivo.model';
import IDocumento from '@models/documentos.interface';

@Component({
    selector: 'app-tabla-general',
    templateUrl: './tabla-general.component.html'
})
export class TablaGeneralComponent {
    @Input() documentos: Archivo[];

    @Output() clicked = new EventEmitter<Archivo>();

    onClick(documento: Archivo) {
        this.clicked.emit(documento);
    }
}
